import { isRejectedWithValue, type Middleware } from '@reduxjs/toolkit'

import { forbiddenDetected } from './forbiddenSlice'

/**
 * Flags a server-enforced 403 from any RTK Query request.
 *
 * The `/c/:customer/` route segment is only a selector. Hand-editing the URL to a
 * forbidden customer yields a 403 from the backend rather than a client-side
 * block. This middleware watches for that rejected query and dispatches
 * `forbiddenDetected`, which `CustomerLayout` turns into a redirect to the
 * unauthorized page. Fires for any customer-scoped query the backend rejects
 * with a 403.
 */
export const forbiddenMiddleware: Middleware = (api) => (next) => (action) => {
  const isRejectedAction =
    isRejectedWithValue(action) &&
    typeof action.payload === 'object' &&
    action.payload !== null &&
    'status' in action.payload &&
    action.payload.status === 403

  if (isRejectedAction) {
    api.dispatch(forbiddenDetected())
  }
  return next(action)
}
